
import { Options, prop, Vue } from "vue-class-component";

class Props {
  isUnderpaid = prop<boolean>({
    default: false,
    type: Boolean
  });
  locale = prop<string>({
    default: "id",
    type: String
  });
}

@Options({})
export default class InvalidIcon extends Vue.with(Props) {
  get normalizedLocale() {
    return (this.locale || "id").toLowerCase() === "my" ? "my" : "id";
  }

  get failedIcon() {
    return this.normalizedLocale === "my"
      ? require("@/app/ui/assets/svg/sti-reverse-scan/icon-scan-failed-my.svg")
      : require("@/app/ui/assets/svg/sti-reverse-scan/icon-scan-failed.svg");
  }
}
